var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 8.33203L15.1242 8.86936C16.2685 9.2127 16.8407 9.38436 17.1702 9.8272C17.4997 10.27 17.4997 10.8674 17.4997 12.0621V18.332",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 7.5H9.16699M6.66699 10.8333H9.16699",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 18.3346V15.8346C9.99967 15.049 9.99967 14.6561 9.75559 14.4121C9.51151 14.168 9.11867 14.168 8.33301 14.168H7.49967C6.714 14.168 6.32117 14.168 6.07708 14.4121C5.83301 14.6561 5.83301 15.049 5.83301 15.8346V18.3346",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 18.332H18.3337",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.3346V5.599C2.5 3.50671 2.5 2.46056 3.15932 1.9415C3.81864 1.42245 4.78952 1.70426 6.73127 2.26789L10.8979 3.47732C12.0697 3.81745 12.6556 3.9875 12.9944 4.45101C13.3333 4.91453 13.3333 5.54584 13.3333 6.80845V18.3346",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company-icon.8537b0b465cccc5e73b240c52640db64.svg";
export { ForwardRef as ReactComponent };